<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="商品分销管理" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
			<div v-if="goods_list" class="pb-30">
				<div v-if="goods_list.length" class="main-content">
					<div v-for="item in goods_list" :key="item.goods_id" @click="onEdit(item.goods_id)" class="div mt-5 inviter-item">
						<div class="div goods-info">
							<div class="p-img">
								<img class="img" :src="item.goods_image"/>
							</div>
							<div class="p-info">
								<div class="name">{{item.goods_name}}</div>
								<div class="price">￥{{item.goods_price}}</div>
							</div>
						</div>
						<div class="inviter-info">
							<div class="info-item">
								<div class="left">已分销</div>
								<div class="right">{{item.inviter_total_quantity}}件</div>
							</div>
							<div class="info-item">
								<div class="left">总金额</div>
								<div class="right">￥{{item.inviter_total_amount}}</div>
							</div>
							<div class="info-item">
								<div class="left">总佣金</div>
								<div class="right">￥{{item.inviter_amount}}</div>
							</div>
						</div>
						<div class="inviter-btn">
							<div class="common-btn" @click="onEdit(item.goods_id)">修改</div>
						</div>
					</div>
				</div>
				<empty-record v-else></empty-record>
			</div>
			<div class='common-add-btn-wrapper'><div class="div common-btn common-add-btn"  @click="goAdd">新增</div></div>
        </div>
    </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { getInviterGoodsList } from '../../../api/sellerInviter'
import EmptyRecord from '../../../components/EmptyRecord'
import flexLine from '../../flexLine'
export default {
  name: 'GoodsList',
  data () {
    return {
    params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      // 分销商品列表
      goods_list: false
    }
  },
  components:{
    flexLine,
    EmptyRecord
  },
  created: function () {
  
  },
  methods: {
    goAdd () {
      this.$router.push({ name: 'SellerInviterGoodsForm', query: { action: 'add' } })
    },
    onEdit (goods_commonid) {
      this.$router.push({ name: 'SellerInviterGoodsForm', query: { goods_commonid: goods_commonid } })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getGoodsList(true)
      }
    },
    reload () {
      // 重新加载数据
      this.params.page = 0
      this.isMore = true
      this.goods_list = []
      this.loadMore()
    },
    getGoodsList () {
      getInviterGoodsList(this.params).then(res => {
        if (this.goods_list) {
              this.goods_list = this.goods_list.concat(res.result.goods_list)
          } else {
              this.goods_list = res.result.goods_list
          }
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.inviter-item{padding: 1rem $pageSpace .5rem;background-color: #fff;border-radius: .5rem;}
.goods-info{display: flex;box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.06);}
.goods-info .p-img{width: 5.5rem;height: 5.5rem;border-radius: .5rem;overflow: hidden;}
.goods-info .p-img .img{width: 5.5rem;height: 5.5rem;}
.goods-info .p-info{margin-left:.4rem;width: 55%;}
.goods-info .p-info .name{color: #333;font-size: .7rem; line-height: .8rem;height: 1.6rem;margin-top: .4rem;overflow: hidden;display: -webkit-box; -webkit-box-orient: vertical;-webkit-line-clamp: 2;padding: 0 .3rem;box-sizing: border-box;}
.goods-info .p-info .price{color:red;line-height:1rem;font-size:0.7rem;padding-top: 1rem;}
.inviter-info{padding: .5rem 0;}
.inviter-info .info-item{border-bottom: 1px dashed #DBDADF;display: flex;padding: .5rem 0;color: #666;font-size: .8rem;}
.inviter-info .info-item .right{margin-left: auto;}
.inviter-btn {display: flex;justify-content: flex-end;}
.inviter-btn .common-btn{border: 1px solid #333;border-radius: 1rem;padding: .2rem 1.3rem;}
</style>
